import { API_BASE_URL, API_BASE_URL_AUTH, getHeaders } from './api';

function getAuthToken() {
  return localStorage.getItem('authToken');
}

function handleUnauthorized() {
  localStorage.removeItem('authToken');
  localStorage.removeItem('authTokenRefreshedAt');
  window.location.href = '/login';
}

let refreshPromise = null;

async function attemptTokenRefresh() {
  if (refreshPromise) return refreshPromise;

  refreshPromise = (async () => {
    const token = getAuthToken();
    if (!token) return null;

    try {
      const response = await fetch(`${API_BASE_URL_AUTH}/auth/refresh-token`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      });
      if (response.ok) {
        const data = await response.json();
        if (data.status === 1 && data.token) {
          localStorage.setItem('authToken', data.token);
          localStorage.setItem('authTokenRefreshedAt', Date.now().toString());
          return data.token;
        }
      }
    } catch (e) {
      console.warn('Token refresh failed:', e.message);
    }
    return null;
  })();

  const result = await refreshPromise;
  refreshPromise = null;
  return result;
}

async function apiRequest(url, options = {}, isRetry = false) {
  const token = getAuthToken();
  const headers = getHeaders(token);

  const response = await fetch(`${API_BASE_URL}${url}`, {
    ...options,
    headers: { ...headers, ...options.headers },
  });

  if (response.status === 401 && !isRetry) {
    const newToken = await attemptTokenRefresh();
    if (newToken) {
      return apiRequest(url, options, true);
    }
    handleUnauthorized();
    throw new Error('Unauthorized');
  }

  if (response.status === 401 && isRetry) {
    handleUnauthorized();
    throw new Error('Unauthorized');
  }

  if (!response.ok) {
    const errorBody = await response.json().catch(() => ({}));
    const error = new Error(errorBody.message || `Request failed with status ${response.status}`);
    error.status = response.status;
    error.data = errorBody;
    throw error;
  }

  if (response.status === 204) {
    return null;
  }

  return response.json();
}

export function apiGet(url) {
  return apiRequest(url, { method: 'GET' });
}

export function apiPost(url, data) {
  return apiRequest(url, {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export function apiPut(url, data) {
  return apiRequest(url, {
    method: 'PUT',
    body: JSON.stringify(data),
  });
}

export function apiDelete(url) {
  return apiRequest(url, { method: 'DELETE' });
}
